<template lang="pug">
  .wrap
    page-title Your Recognise report
      template(slot='actions')
        a(:href="reportCsvUrl")
          el-button Export as CSV

    time-switcher(v-model='apiDateRange' v-if='breakdownStats && breakdownStats.totals.overall')

    .detail(v-if='!loading && breakdownStats && breakdownStats.totals.overall')
      el-row(:gutter='20' v-loading='loading')
        el-col(:sm='8')
          .detail-count(:key='loading ? "forceRefresh" : "done"' @click='navigateToList')
            circular-counter(id='detail' label='Recognitions'
              :total='breakdownStats.totals.overall' :count='breakdownStats.totals.total' color='#ef5c47')

            .counter-action
              el-button(type='primary' @click='navigateToList') View all

        el-col(:sm='16')
          chart-wrap
            date-counts-chart(:chart-data="dateBreakdownChartData" :options='breakdownChartOptions' :height='250')

    .empty(v-else-if='!loading')
      recognition-list-empty

</template>

<script>
import _ from "lodash";
import format from "date-fns/format";
import startOfWeek from "date-fns/start_of_week";
import endOfWeek from "date-fns/end_of_week";
import eachDay from "date-fns/each_day";
import ChartWrap from "@/shared/components/ChartWrap";

import { mapGetters, mapActions } from "vuex";

import PageTitle from "@/shared/components/layout/PageTitle";
import CircularCounter from "@/shared/components/CircularCounter";
import TimeSwitcher from "@/brapp/components/shared/TimeSwitcher";
import DateCountsChart from "./DateCountsChart";
import RecognitionListEmpty from "../RecognitionListEmpty";

const formatApiDate = date => format(date, "YYYY-MM-DD");

const DEFAULT_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: "right"
  },
  layout: {
    padding: 20
  },
  scales: {
    yAxes: [
      {
        ticks: {
          suggestedMin: 20,
          stepSize: 5
        },
        gridLines: {
          display: true,
          color: "rgba(0, 0, 0, 0.03)"
        }
      }
    ]
  }
};

export default {
  components: {
    TimeSwitcher,
    DateCountsChart,
    CircularCounter,
    PageTitle,
    RecognitionListEmpty,
    ChartWrap
  },
  data() {
    const now = Date.now();
    const start = startOfWeek(now, { weekStartsOn: 1 });
    const end = endOfWeek(now, { weekStartsOn: 1 });
    const apiDateRange = [formatApiDate(start), formatApiDate(end)];

    return {
      loading: false,
      apiDateRange,
      dateRange: eachDay(start, end),
      breakdownStats: null,
      breakdownChartOptions: {
        ...DEFAULT_CHART_OPTIONS,
        legend: {
          display: false
        }
      }
    };
  },
  computed: {
    ...mapGetters("api", ["generateUrl"]),
    ...mapGetters("auth", ["activeCompany"]),
    reportCsvUrl() {
      const params = {
        format: "csv",
        start: this.apiDateRange[0],
        end: this.apiDateRange[1],
        company: _.get(this.activeCompany, "id")
      };
      return this.generateUrl({
        path: "/brapp/reports/recognise/overall/",
        params
      });
    },
    dateBreakdownChartData() {
      const labels = this.breakdownStats.dayGroups.map(g => g.date);
      const datasets = [
        {
          backgroundColor: "#f15b40",
          label: "",
          data: this.breakdownStats.dayGroups.map(g => g.count)
        }
      ];
      return {
        labels,
        datasets
      };
    }
  },
  watch: {
    apiDateRange(newVal) {
      this.onRangeChange(newVal);
    }
  },
  methods: {
    ...mapActions("reports", ["fetchRecogniseOverallStats"]),
    loadData({ params = {} } = {}) {
      this.loading = true;
      this.fetchRecogniseOverallStats({ params }).then(data => {
        this.loading = false;
        this.breakdownStats = data;
      });
    },
    onRangeChange(dateRange) {
      const params = {
        start: formatApiDate(dateRange[0]),
        end: formatApiDate(dateRange[1])
      };
      this.loadData({ params });
    },
    selectCategory(categoryId) {
      this.selectedCategoryId = categoryId;
      this.loadCategoryBreakDown({ categoryId });
    },
    navigateToList() {
      this.$router.push({ name: "recognitionList" });
    }
  },
  created() {
    this.loadData({
      params: { start: this.apiDateRange[0], end: this.apiDateRange[1] }
    });
  }
};
</script>

<style scoped lang="scss">
.charts {
  background: white;
  padding: 20px;
}

.summary-chart-wrap {
  margin: 20px 0;
}

.line-chart-wrap {
  margin-top: 30px;
  padding: 0 30px;
}

.tabs {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.detail {
  margin-top: 30px;
  background: white;
  padding: 30px;
}

.detail-count {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
}

.counter-action {
  margin-top: 20px;
}

.accordion-row {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.accordion-row-label {
  flex: 0 0 auto;
}

.accordion-row-count {
  flex: 0 0 auto;
  margin-left: auto;
}

.circles {
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle {
  margin: 0 40px;
}

.tabs {
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-direction: row;
}

.tab {
  background: white;
  margin: 0 4px;
  padding: 10px 20px;
  align-items: center;
  flex-direction: column;
  border: 1px solid #eee;
  font-size: 20px;
  cursor: pointer;
  transition: background 250ms ease-in-out;

  &.active {
    background: #ddd;
  }
}

.emptystate {
  width: 100%;
}
</style>
